import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGatewayGetTransactionsPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/transactions/models/inputs/gateway-get-transactions-paginated.form-default-values';
import { GatewayGetTransactionsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/transactions/models/inputs/gateway-get-transactions-paginated.model';
import { formatISO } from 'date-fns';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterTransactionListContextProvider,
  useTransactionListContext,
} from '../transaction.context';
import { TransactionListFilterFormController } from './transaction-list-filter-form/transaction-list-filter-form.controller';

interface TransactionListFilterControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const TransactionListFilterController = ({
  onCancel,
  onSuccess,
}: TransactionListFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useTransactionListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<
    GatewayGetTransactionsPaginatedModel
  > = (errors) => {
    Logger.error(errors);
    toast.error(
      t('$.transaction-list-filter.error', { error: t('global.unknown') }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GatewayGetTransactionsPaginatedModel
  > = (fieldValues) => {
    setGetPaginatedQueryParameters((current) => {
      return {
        ...current,
        locationId: fieldValues.locationId,
        chargePointId: fieldValues.chargePointId,
        currentState: fieldValues.currentState,
        createdAfter: fieldValues.createdAfter
          ? formatISO(fieldValues.createdAfter)
          : undefined,
        createdBefore: fieldValues.createdBefore
          ? formatISO(fieldValues.createdBefore)
          : undefined,
      };
    });
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGatewayGetTransactionsPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterTransactionListContextProvider data={data}>
      <TransactionListFilterFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterTransactionListContextProvider>
  );
};
